import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';

import { EditBaseMappingComponent } from '../features/lt-endpoint/components/edit-base-mapping/edit-base-mapping.component';

@Injectable()
export class EditBaseMappingGuard  {

    canDeactivate(component: EditBaseMappingComponent): boolean | Observable<boolean> | Promise<boolean> {
          return component.canDeactivate() ? true :
            window.confirm('You are about to leave the page without saving your changes. Are you sure you want to leave this page?');
    }

}
